import * as React from "react";
import { BasePureComponent } from "./BaseComponent";
import { Trad, Tipo, CampoData, BottoneAPI } from "./";
import * as Dati from "../Dati";
import * as Glob from "../Globale";
import { MinDateOfBirth } from "../DatiRCP";

interface IBaseAnagraficaProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON;
    Stato?: string;
    OnChangeDetailsType: (v: string) => void;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label: string, fieldTypeId: number, elementGroup?: any) => any;
}

export class BaseAnagrafica extends BasePureComponent<IBaseAnagraficaProps> {
    private _Anagrafica: Dati.CAnagrafica = new Dati.CAnagrafica();
    private _CSS_PersonaFisica: string = "hidden";
    private _CSS_DittaIndividuale: string = "hidden";
    private _CSS_PersonaGiuridica: string = "hidden";
    private _modalNome: string = "";
    private _modalCognome: string = "";
    private _modalCF: string = "";
    private _Stato: string = "";

    public constructor(props: any) {
        super(props);
        this.OnChange = this.OnChange.bind(this);
    }

    private Inizializza(props: IBaseAnagraficaProps) {
        this._Stato = props.Stato != undefined ? props.Stato : Glob.Tipi_AS_InAcquisizione;
        this.PopolaValori(props.Value);
    }

    private PopolaValori(valore: string) {
        this._Anagrafica = new Dati.CAnagrafica();
        if (valore != undefined && valore != "") this._Anagrafica = JSON.parse(valore);
        else this._Anagrafica = new Dati.CAnagrafica();

        if (this._Anagrafica.ID_TipoSocieta == undefined) this._Anagrafica.ID_TipoSocieta = 7;

        this.OnNascondiDati(this._Anagrafica.ID_TipoAnagPrincipale);
    }

    private OnInvioSalvaRappresentante(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPITipi<Dati.CDatiAnag>();
        Ingr.Dato.Nome = this._modalNome;
        Ingr.Dato.Cognome = this._modalCognome;
        Ingr.Dato.RagioneSociale = "";
        Ingr.Dato.PartitaIVA = "";
        Ingr.Dato.CodiceFiscale = this._modalCF;
        Ingr.Dato.DataNascita = new Date("1901-01-01");
        Ingr.Dato.LuogoNascita = "";
        Ingr.Dato.Sesso = "";
        Ingr.Dato.RecapitiJSON = "";
        Ingr.Dato.IndirizziJSON = "";
        Ingr.Dato.MandantiJSON = "";
        Ingr.Dato.ID_TipoAnagPrincipale = Glob.Tipi_TAP_PersonaFisica;
        Ingr.Dato.ID_TipoAnagStato = Glob.Tipi_AS_Attivo;
        return Ingr;
    }

    private OnCambiaLegaleRappresentante(campo: string, valore: string) {
        switch (campo) {
            case "modalNome":
                this._modalNome = valore;
                break;
            case "modalCognome":
                this._modalCognome = valore;
                break;
            case "modalCodiceFiscale":
                this._modalCF = valore;
                break;
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), errore.message);
    }

    protected OnAggiorna(): void {
        this.props.OnChange(this.props.Name, JSON.stringify(this._Anagrafica));
    }

    protected OnChange(id: string, value: any, fieldTypeId: number = 0): void {
        this._Anagrafica[id] = value;
        this.OnAggiorna();
        if (this.props.OnChangeAppendice) {
            this.props.OnChangeAppendice(`AnagraficaContraente.${id}`, value, id, fieldTypeId);
        }
    }

    private OnNascondiDati(valore: string) {
        switch (valore) {
            case Glob.Tipi_TAP_PersonaFisica:
                this._CSS_PersonaFisica = "";
                this._CSS_PersonaGiuridica = "hidden";
                this._CSS_DittaIndividuale = "hidden";
                break;
            case Glob.Tipi_TAP_PersonaGiuridica:
            case Glob.Tipi_TAP_ATI:
                this._CSS_PersonaFisica = "hidden";
                this._CSS_PersonaGiuridica = "";
                this._CSS_DittaIndividuale = "";
                break;
            case Glob.Tipi_TAP_Beneficiario:
                this._CSS_PersonaFisica = "hidden";
                this._CSS_PersonaGiuridica = "";
                this._CSS_DittaIndividuale = "";
                break;
            case Glob.Tipi_TAP_DittaIndividuale:
                this._CSS_PersonaFisica = "";
                this._CSS_PersonaGiuridica = "hidden";
                this._CSS_DittaIndividuale = "";
                break;
            default:
                this._CSS_PersonaFisica = "hidden";
                this._CSS_PersonaGiuridica = "hidden";
                this._CSS_DittaIndividuale = "hidden";
                break;
        }
        /*  this.forceUpdate();*/
    }

    private OnClickSalvaRappresentante(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            this._Anagrafica.ID_AnagLegaleRappresentante = dati.ID_Chiave;
            Glob.InfoModaleSuccess(Trad.Trad("ANAGRAFICA"), Trad.Trad("Anagrafica salvata correttamente con ID: " + dati.ID_Chiave));
            this.OnAggiorna();
        }
    }

    public render() {
        this.Inizializza(this.props);
        return (
            <div>
                <div className="form-group kt-form login-form__group row">
                    <div className="col-lg-3">
                        <label>ID</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control kt-input"
                                value={this._Anagrafica.ID_Anag}
                                name="ID_Anag"
                                id="ID_Anag"
                                onChange={e => this.OnChange("ID_Anag", e.target.value, 2)}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className={this._Stato == Glob.Tipi_AS_Attivo ? "col-lg-3 hidden" : "col-lg-3"}>
                        <label className="">{Trad.Trad("Stato")}</label>
                        <Tipo
                            Campo="ID_AnagStato"
                            ID_ChiaveString={this._Anagrafica.ID_TipoAnagStato || this._Stato}
                            OnAggiorna={(c, v) => {
                                this.OnChange("ID_TipoAnagStato", v, 7);
                            }}
                            URL="/api/Tipi/ListaTipi?ID_TipoContesto=AnagStato"
                        />
                    </div>
                    <div className="col-lg-4">
                        <label className="">{Trad.Trad("Tipo Anagrafica")}</label>
                        <Tipo
                            Campo="ID_TipoAnagPrincipale"
                            ID_ChiaveString={this._Anagrafica.ID_TipoAnagPrincipale}
                            OnAggiorna={(c, v) => {
                                this.OnNascondiDati(v);
                                this.props.OnChangeDetailsType(v);
                                this.OnChange("ID_TipoAnagPrincipale", v, 7);
                            }}
                            URL="/api/Tipi/ListaTipi?ID_TipoContesto=TipiAnagPrincipale"
                        />
                    </div>
                </div>
                <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaGiuridica}>
                    <div className="col-lg-6">
                        <label>{Trad.Trad("Ragione Sociale")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.RagioneSociale || ""}
                                id="RagioneSociale"
                                name="RagioneSociale"
                                onChange={e => this.OnChange("RagioneSociale", e.currentTarget.value, 2)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <label>{Trad.Trad("Tipo Società")}</label>
                        <Tipo
                            URL="/api/Tipi/Tipo?tabella=TipiSocieta&campo=TipoSocieta"
                            Campo="ID_TipoSocieta"
                            ID_ChiaveString={this._Anagrafica.ID_TipoSocieta.toString() || ""}
                            OnAggiorna={(c, v) => {
                                this.OnChange("ID_TipoSocieta", v, 7);
                            }}
                        />
                    </div>
                    {Glob.AzioneAbilitata("CapogruppoAnag", Glob.Lettura) && (
                        <div className="col-lg-3">
                            <label>{Trad.Trad("Capogruppo")}</label>
                            <Tipo
                                URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                Campo="ID_AnagCapoGruppo"
                                ID_Chiave={this._Anagrafica.ID_AnagCapoGruppo}
                                OnAggiorna={(c, v) => {
                                    this.OnChange("ID_AnagCapoGruppo", v, 7);
                                }}
                                TradValori
                                LinkSelezione="/anagrafica/"
                            />
                        </div>
                    )}
                </div>
                <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaFisica}>
                    <div className={"col-lg-3 " + this._CSS_PersonaFisica}>
                        <label>{Trad.Trad("Nome")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.Nome || ""}
                                id="Nome"
                                name="Nome"
                                onChange={e => this.OnChange("Nome", Glob.CapitalizeFirstLetter(e.currentTarget.value), 2)}
                            />
                        </div>
                    </div>
                    <div className={"col-lg-3 " + this._CSS_PersonaFisica}>
                        <label>{Trad.Trad("Cognome")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.Cognome || ""}
                                id="Cognome"
                                name="Cognome"
                                onChange={e => this.OnChange("Cognome", Glob.CapitalizeFirstLetter(e.currentTarget.value), 2)}
                            />
                        </div>
                    </div>
                    <div className={"col-lg-3" + this._CSS_PersonaFisica}>
                        <label>{Trad.Trad("CF")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.CodiceFiscale || ""}
                                id="CodiceFiscale"
                                name="CodiceFiscale"
                                onChange={e => {
                                    this._Anagrafica.CodiceFiscale = e.currentTarget.value.toUpperCase();
                                    this.OnAggiorna();
                                }}
                                pattern={Glob.REGEXPerControlloPIVA(this._Anagrafica.ID_TipoAnagPrincipale, (this._Anagrafica.CodiceFiscale || "").length)}
                            />
                        </div>
                    </div>
                    <div className={"col-lg-3 " + this._CSS_DittaIndividuale}>
                        <label>{Trad.Trad("PIVA")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.PartitaIVA || ""}
                                id="PartitaIVA"
                                name="Dato.PartitaIVA"
                                onChange={e => this.OnChange("PartitaIVA", e.currentTarget.value, 2)}
                                pattern={Glob.REGEX_PIVA}
                            />
                        </div>
                    </div>
                </div>
                <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaFisica}>
                    <div className="col-lg-3">
                        <label className="">{Trad.Trad("Data nascita")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <div className="form-control">
                                <CampoData
                                    ValoreInArrivo={false}
                                    Name="DataNascita"
                                    Id="DataNascita"
                                    DataMassima={MinDateOfBirth}
                                    Valore={this._Anagrafica.DataNascita}
                                    OnChange={(e, v) => {
                                        this.OnChange("DataNascita", v, 3);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <label>{Trad.Trad("Luogo nascita")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.LuogoNascita || ""}
                                id="LuogoNascita"
                                name="LuogoNascita"
                                onChange={e => this.OnChange("LuogoNascita", Glob.CapitalizeFirstLetter(e.currentTarget.value), 2)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <label>{Trad.Trad("Sesso")}</label>
                        <div className="kt-radio-list">
                            <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                <input
                                    name="Sesso"
                                    value="F"
                                    type="radio"
                                    checked={this._Anagrafica.Sesso == "F"}
                                    onChange={() => {
                                        this.OnChange("Sesso", "F", 2);
                                    }}
                                />
                                {Trad.Trad("Femmina")}
                                <span></span>
                            </label>
                            <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                <input
                                    name="Sesso"
                                    value="M"
                                    type="radio"
                                    checked={this._Anagrafica.Sesso == "M"}
                                    onChange={() => {
                                        this.OnChange("Sesso", "M", 2);
                                    }}
                                />
                                {Trad.Trad("Maschio")}
                                <span></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaGiuridica}>
                    <div className="col-lg-3">
                        <label>{Trad.Trad("PIVA")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.PartitaIVA || ""}
                                id="PartitaIVA"
                                name="PartitaIVA"
                                onChange={e => this.OnChange("PartitaIVA", e.currentTarget.value, 2)}
                                pattern={Glob.REGEX_PIVA}
                            />
                        </div>
                    </div>
                    <div className={"col-lg-3 " + this._CSS_DittaIndividuale}>
                        <label>{Trad.Trad("CF")}</label>
                        <div className="kt-input-icon kt-input-icon--right">
                            <input
                                type="text"
                                className="form-control"
                                value={this._Anagrafica.CodiceFiscale || ""}
                                id="CodiceFiscale"
                                name="CodiceFiscale"
                                onChange={e => {
                                    this._Anagrafica.CodiceFiscale = e.currentTarget.value.toUpperCase();
                                    this.OnAggiorna();
                                }}
                                pattern={Glob.REGEXPerControlloPIVA(this._Anagrafica.ID_TipoAnagPrincipale, (this._Anagrafica.CodiceFiscale || "").length)}
                            />
                        </div>
                    </div>
                    <div className={"col-lg-5 " + this._CSS_DittaIndividuale}>
                        <label>{Trad.Trad("Legale Rappresentante")}</label>
                        <Tipo
                            URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                            Campo="ID_AnagLegaleRappresentante"
                            ID_Chiave={this._Anagrafica.ID_AnagLegaleRappresentante}
                            OnAggiorna={(c, v) => {
                                this.OnChange("ID_AnagLegaleRappresentante", v, 7);
                            }}
                            TradValori
                            LinkSelezione="/anagrafica/"
                        />
                    </div>
                    <div className="col-lg-1">
                        <label className="bianco">{Trad.Trad("Aggiungi")}</label>
                        <button type="button" className="btn btn-brand" data-toggle="modal" data-target="#modaleInsAnagrafica" id="btnModaleInsAnagrafica">
                            <i className="fa fa-plus"></i>
                        </button>
                    </div>
                    <div className="modal fade" id="modaleInsAnagrafica" role="dialog" aria-labelledby="modaleInsAnagrafica" style={{ display: "none" }} aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header alert-info">
                                    <h5 className="modal-title" id="modaleAnagTitolo">
                                        {Trad.Trad("Inserimento Legale Rappresentante")}
                                    </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body" id="modaleAnagTesto">
                                    <div className="form-group kt-form login-form__group row">
                                        <div className="col-lg-6">
                                            <label>{Trad.Trad("Nome")}</label>
                                            <div className="kt-input-icon kt-input-icon--right">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this._modalNome}
                                                    id="modalNome"
                                                    name="modalNome"
                                                    onChange={e => this.OnCambiaLegaleRappresentante("modalNome", Glob.CapitalizeFirstLetter(e.currentTarget.value))}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <label>{Trad.Trad("Cognome")}</label>
                                            <div className="kt-input-icon kt-input-icon--right">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this._modalCognome}
                                                    id="modalCognome"
                                                    name="modalCognome"
                                                    onChange={e => this.OnCambiaLegaleRappresentante("modalCognome", Glob.CapitalizeFirstLetter(e.currentTarget.value))}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group kt-form login-form__group row">
                                        <div className="col-lg-12">
                                            <label>{Trad.Trad("CF")}</label>
                                            <div className="kt-input-icon kt-input-icon--right">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this._modalCF}
                                                    id="modalCodiceFiscale"
                                                    name="modalCodiceFiscale"
                                                    onChange={e => this.OnCambiaLegaleRappresentante("modalCodiceFiscale", e.currentTarget.value.toUpperCase())}
                                                    pattern={Glob.REGEX_CF}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <BottoneAPI
                                        Default={false}
                                        Testo={Trad.Trad("Inserisci")}
                                        URL={`/api/anag/SalvaAnagraficaAsync`}
                                        Metodo="POST"
                                        OnInvio={s => this.OnInvioSalvaRappresentante(s)}
                                        OnClick={(s, d) => this.OnClickSalvaRappresentante(s, d)}
                                        OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                        DataDismiss="modal"
                                    />
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal" id="btnModaleInsAnagraficaChiudi">
                                        {Trad.Trad("Chiudi")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BaseAnagrafica.tsx